import ProductOptionFilter from './ProductOptionFilter'
import ProductSingleOptionFilter from './ProductSingleOptionFilter'
import ProductRangeFilter from './ProductRangeFilter'
import ProductRangeOptionFilter from './ProductRangeOptionFilter'
import ProductStaticFilter from './ProductStaticFilter'

export default {
    'options': ProductOptionFilter,
    'min': ProductSingleOptionFilter,
    'max': ProductSingleOptionFilter,
    'static': ProductStaticFilter,
    'no_of_outputs_dual': ProductStaticFilter,
    'range': ProductRangeFilter,
    'decimal_range': ProductRangeFilter,
    'range_inputs': ProductRangeOptionFilter,
    'range_inputs_ignore_dual': ProductRangeOptionFilter,
    'output_voltage_dual': ProductRangeOptionFilter,
    'custom': ProductRangeOptionFilter,
    'range_inputs_between': ProductRangeOptionFilter,
}
